import { INTERVAL, interval_milliseconds_names } from '@voladeum/client';

export const hydrateDataset = <T extends Record<string, any>>(
  data: T[],
  empty: T,
  start: number,
  finish: number,
  milliseconds = interval_milliseconds_names[INTERVAL.DAY]
): T[] => {
  const map = new Map<number, T>();
  const intervals: T[] = [];

  data.forEach((item) => {
    const start = Math.floor(item.since_milliseconds / milliseconds) * milliseconds;
    map.set(start, item);
  });

  let current = Math.floor(start / milliseconds) * milliseconds;
  const next = Math.floor(finish / milliseconds) * milliseconds;

  while (current <= next) {
    if (map.has(current)) {
      intervals.push(map.get(current)!);
    } else {
      const emptyObj = {
        ...empty,
        since_milliseconds: current,
        to_milliseconds: current + milliseconds,
      } as T;

      intervals.push(emptyObj);
    }
    current += milliseconds;
  }

  return intervals;
};

export const filterTimeseries = (data: any[], visible: { start: number; end: number }): number[] =>
  data
    .filter(
      (d): d is { x: number; y: number } =>
        !!d &&
        typeof d === 'object' &&
        typeof d.x === 'number' &&
        d.x >= visible.start &&
        d.x <= visible.end &&
        typeof (d as any).y === 'number'
    )
    .map((d) => (d as any).y)
    .filter((v) => !Number.isNaN(v));

export const getMinMax = (values: number[]): { min: number; max: number } =>
  values.length === 0 ? { min: 0, max: 0 } : { min: Math.min(...values), max: Math.max(...values) };
